export default `
  fragment AuthorBylineFragment on authors {
    id
    slug
    name
    booksCount:books_count
    image:cached_image
  }
`;
